import React from 'react';
import './scss/App.scss';
import Dashboard from './pages/Dashboard.js';

const App = () => {
  return (
    <div className="App">
        <Dashboard />
    </div>
  );
}

export default App;